<template>
  <subform-controller
    v-if="isCoverTypeHadContents"
    :form-observer="formObserver"
    :show-confirm-modal="showConfirmModal"
    :is-subform-visible="questionData.propertyLaptopInsurance"
    :form-items="questionData.bicyclesOrLaptopsDetails"
    :subform="FormBicycleLaptop"
    :max-amount="constants.COVER_ITEMS_MAX_AMOUNT"
    :payload-template="BICYCLE_OR_LAPTOP_DETAIL"
    :get-rules="getBicycleLaptopRules"
    :step-id="stepId"
    section-item-name="bicycle_laptop"
    @set-items="questionData.bicyclesOrLaptopsDetails = $event"
    @set-question="questionData.propertyLaptopInsurance = $event"
  >
    <template #question>
      <form-row
        id="property-laptop-insurance"
        label="Do you want to insure any bicycles or laptops?"
      >
        <validation-provider
          v-slot="{ failed }"
          name="Property Laptop Insurance"
          :vid="`${stepId}_property-laptop-insurance`"
          :rules="{ required: isCoverTypeHadContents }"
          slim
        >
          <radio
            v-model="questionData.propertyLaptopInsurance"
            name="insure-bicycles-or-laptops"
            wide
            :error="failed"
            :items="constants.YES_NO"
            data-test="bicycles-laptops"
          />
        </validation-provider>
      </form-row>
    </template>
    <template
      #preview="{ item: { item } }"
    >
      <subform-preview
        :preview-list="getSubformPreview(item)"
        :icon="getSubformPreviewIcon(item)"
      />
    </template>
  </subform-controller>
</template>

<script>
import QuestionBase from '@/components/questions/Base';
import SubformController from '@/components/SubformController/SubformController';
import SubformPreview from '@/components/SubformController/SubformPreview';

import FormBicycleLaptop from '@/components/home/FormBicycleLaptop/FormBicycleLaptop';

import {
  CONTENT,
  BICYCLE_OR_LAPTOP_DETAIL,
} from '@/payloadTemplates/home';

import { getBicycleLaptopRules } from '@/prevalidation/home';

export default {
  name: 'question-property-laptop-insurance',
  extends: QuestionBase,
  components: {
    SubformController,
    SubformPreview,
  },
  props: {
    showConfirmModal: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      fields: ['propertyLaptopInsurance', 'bicyclesOrLaptopsDetails'],
    };
  },
  computed: {
    isCoverTypeHadContents () {
      const type = this.formData.home.propertyCoverType;
      return type === 'BC' || type === 'C';
    },
  },
  created () {
    if (!this.isCoverTypeHadContents) {
      this.questionData.propertyLaptopInsurance = CONTENT.propertyLaptopInsurance;
      this.questionData.bicyclesOrLaptopsDetails = CONTENT.bicyclesOrLaptopsDetails;
    }
  },
  methods: {
    getSubformPreviewIcon (item) {
      return item.propertyBicycleOrLaptop === 'L' ? 'mdi-laptop' : 'mdi-bicycle';
    },
    getSubformPreview (item) {
      return this.helpers.getFormattedSubformPreviewList(item);
    },
  },
  setup () {
    return {
      FormBicycleLaptop,
      getBicycleLaptopRules,
      BICYCLE_OR_LAPTOP_DETAIL,
    };
  },
};
</script>

<style lang="scss" scoped>
.summary-item-wrap {
  list-style: disc;
  margin-left: 5px;
}
</style>
